<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive"  v-if="value.length">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Documento</th>
                                <th>Extensão</th>
                                <th>Tamanho</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(file, index) in value" :key="file.id">
                                <td class="td-name">
                                    <img v-if="isImage(file)" :src="getImg(file)" style="height: 35px; width: 5%;" />
                                    <input refs="name" type="text" v-model="file.name" class="form-control" style="margin-left: 10px; width: 95%;" v-alpha-only />
                                </td>
                                <td>{{ file.extension }}</td>
                                <td>{{file.size | formatSize }}</td>
                                <td class="td-actions">
                                    <button @click="removeFile(index)" type="button" rel="tooltip" data-placement="left" title="Remove item" class="btn btn-link">
                                        <i class="material-icons">close</i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <file-upload
                    class="btn btn-primary"
                    :multiple="true"
                    :drop="true"
                    :drop-directory="true"
                    v-model="newFiles"
                    ref="upload"
                    @input="updateFiles">
                    <i class="fa fa-plus"></i>
                    Selecione os documentos
                </file-upload>
            </div>
        </div>
    </div>
</template>

<script>
function uniqueID(){
  function chr4(){
    return Math.random().toString(16).slice(-4);
  }
  return chr4() + chr4() +
    '-' + chr4() +
    '-' + chr4() +
    '-' + chr4() +
    '-' + chr4() + chr4() + chr4();
}

export default {
    data() {
        return {
            newFiles: []
        }
    },
    props: ['items', 'value'],
    methods: {
        addFiles(_file) {
            var fileName = _file.file.name.split('.');
            var name = fileName[0];
            var extension = fileName[1];
            var self = this;
                       
            const file64 = self.convertFileToBase64(_file.file);
            file64.then(function (_data) {
                var fileExist = self.value.find(file => file.name == name && file.extension == extension && file.size == _file.size);
                if (fileExist) {
                    return ;
                }
                self.value.push({
                    id: uniqueID(),
                    name: name,
                    extension: extension,
                    size: _file.size,
                    contentType: _file.type,
                    content: _data
                });
            });
        },
        addObjectToFiles(_objectFile) {
            var self = this;
            self.value.push({
                id: _objectFile.id,
                name: _objectFile.name,
                extension: _objectFile.extension,
                size: _objectFile.size,
                contentType: _objectFile.contentType,
                content: _objectFile.content
            });
        },
        convertFileToBase64(_file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsBinaryString(_file);
                reader.onload = () => resolve(window.btoa(reader.result));
                reader.onerror = error => reject(error);
            });
        },
        getImg(_file) {
            return 'data: ' + _file.contentType + ';base64,' + _file.content;
        },
        updateFiles: function (_files) {
            var self = this;
            _files.forEach(function (_file, _key) {
                self.addFiles(_file);
            });
        },
        isImage(_file) {
            var contentTypesImages = ["image/png", "image/jpg", "image/jpeg", "image/gif"];

            if (contentTypesImages.indexOf(_file.contentType) != -1) {
                return true;
            }

            return false;
        },
        removeFile(_indexFile) {
            var self = this;
            self.value.splice(_indexFile, 1);
        },
        processFiles() {
            var self = this;
            for (let index = 0; index < self.items.length; index++) {
                const file = self.items[index];
                self.addObjectToFiles(file);
            }
        }
    },
    mounted () {
        setTimeout(this.processFiles, 1500);
    }
}
</script>
